var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main",staticStyle:{"clear":"both","min-height":"100vh","overflow":"hidden"}},[_c('transition',{staticStyle:{"height":"100%"},attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticStyle:{"height":"100%"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }